<template>
  <div id="schlagwort-component">
    <div id="schlagwort-text" :style="textBackground">{{ schlagwort }}</div>
    <div id="schlagwort-arrow">
      <b-icon-arrow-right class="arrow" v-if="!isLastSchalgwort"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "SchlagwortComponent",
  props: {
    schlagwort: String,
    isLastSchalgwort: Boolean,
    type: String
  },
  computed: {
    textBackground() {
      if (this.type === "answer") {
        return 'background-color: var(--bg-dark);'
      } else {
        return 'background-color: var(--border-blue); color: white'
      }
    }
  }
}
</script>

<style scoped>
#schlagwort-text {
  border: 2px solid var(--border-blue);
  padding: 10px;
  grid-area: schlagwort-text;
  height: auto;
  text-align: center;
}

#schlagwort-component {
  display: grid;
  grid-template-areas:
      "schlagwort-text schlagwort-arrow";
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 40px;
}

#schlagwort-arrow {
  grid-area: schlagwort-arrow;
  align-self: center;
}

.arrow {
  width: 40px;
  height: 40px;
  color: var(--border-blue);
}

</style>